import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Card, F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

type BudgetType = 'trainings' | 'expenses'

interface SelectBudgetTypeModalProps {
  onClose: () => void
  onSelectTrainings: () => void
  onSelectExpenses: () => void
}

export const SelectBudgetTypeModal: React.FC<SelectBudgetTypeModalProps> = ({
  onClose,
  onSelectTrainings,
  onSelectExpenses
}) => {
  const [selectedType, setSelectedType] = useState<BudgetType | null>(null)

  const handleSelect = () => {
    if (selectedType === 'trainings') {
      onSelectTrainings()
    } else if (selectedType === 'expenses') {
      onSelectExpenses()
    }
  }

  return (
    <F0Dialog
      isOpen
      onClose={onClose}
      title={i18n.t('budgets.type_selection.title')}
      width="md"
      primaryAction={{
        label: i18n.t('budgets.type_selection.select'),
        onClick: handleSelect,
        disabled: !selectedType
      }}
      secondaryAction={{
        label: i18n.t('budgets.type_selection.cancel'),
        onClick: onClose
      }}
    >
      <Box gap="s16" flexDirection="row" alignItems="stretch">
        <Box style={{ flex: '1', display: 'flex' }}>
          <F0Card
            avatar={{ type: 'emoji', emoji: '📚' }}
            title={i18n.t('budgets.type_selection.trainings.title')}
            description={i18n.t('budgets.type_selection.trainings.description')}
            onClick={() => setSelectedType('trainings')}
            selected={selectedType === 'trainings'}
            fullHeight
          />
        </Box>
        <Box style={{ flex: '1', display: 'flex' }}>
          <F0Card
            avatar={{ type: 'emoji', emoji: '🧾' }}
            title={i18n.t('budgets.type_selection.expenses.title')}
            description={i18n.t('budgets.type_selection.expenses.description')}
            onClick={() => setSelectedType('expenses')}
            selected={selectedType === 'expenses'}
            fullHeight
          />
        </Box>
      </Box>
    </F0Dialog>
  )
}
